<template>
  <div class="wrap">
    <div class="support_header">
      <div class="form-group--wrap">
        <div class="form-group">
          <label> {{ translate('support.search') }}</label>
          <input
            type="text"
            class="form-control"
            v-model="search"
            :placeholder="translate('support.search')"
          >
          <span
            v-show="check_search"
            class="mdi mdi-close"
            @click.prevent="clear_search()"
          >
          </span>
        </div>
        <span
          class="mdi mdi-magnify btn btn-success btn-fill"
          @click.prevent="get_search()"
        >
        </span>
      </div>
      <span
        v-if="show_new_ticket"
        class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
        @click.prevent="new_ticket({})"
      >
        <b>{{ translate('support.add') }}</b>
      </span>
    </div>


    <div v-if="tickets.length < 1">
      <h1 style="text-align: center" >
        {{translate('no_data')}}
      </h1>
    </div>

    <div v-else class="row response_table">
      <table>
        <thead>
          <tr>
            <th scope="col" @click="change_filter('id')" class="pointer w1" :class="{'selected' : filter_type === 'id'}">
              ID
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'id'}"></i>
            </th>
            <th scope="col" @click="change_filter('title')" class="pointer w4" :class="{'selected' : filter_type === 'title'}">
              {{ translate('support.topic') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'title'}"></i>
            </th>
            <th scope="col" @click="change_filter('device_fid')" class="pointer w4" :class="{'selected' : filter_type === 'device_fid'}">
              {{ translate('support.device') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'device_fid'}"></i>
            </th>
            <th scope="col" @click="change_filter('user_name')" class="pointer w10" :class="{'selected' : filter_type === 'user_name'}">
              {{ translate('support.user') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'user_name'}"></i>
            </th>
            <th scope="col" @click="change_filter('status')" class="pointer w3" :class="{'selected' : filter_type === 'status'}">
              {{ translate('support.status') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'status'}"></i>
            </th>
            <th scope="col" @click="change_filter('ts_update')" class="pointer w4" :class="{'selected' : filter_type === 'ts_update'}">
              {{ translate('support.update') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'ts_update'}"></i>
            </th>
            <th scope="col" @click="change_filter('user_updated')" class="pointer w10" :class="{'selected' : filter_type === 'user_updated'}">
              {{ translate('support.user_update') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'user_updated'}"></i>
            </th>
            <th scope="col" @click="change_filter('executor_user_name')" class="pointer w10" :class="{'selected' : filter_type === 'executor_user_name'}">
              {{ translate('support.executor') }}
              <i class="mdi mdi-arrow-down" :class="{'reverse' : filter_asc === 'asc' && filter_type === 'executor_user_name'}"></i>
            </th>
          </tr>
        </thead>
        <tbody>

          <tr v-if="loading" class="loading">
            <td> <scale-loader /> </td>
          </tr>

          <tr
            v-for="(ticket,key) in tickets"
            :key="key"
            class="ticket"
            @click="show_ticket(ticket.id)"
          >
            <td data-label="ID" class="w1" >
              {{ ticket.id }}
            </td>
            <td :data-label="translate('support.topic')" class="w4">
              {{ ticket.title }}
            </td>
            <td :data-label="translate('support.device')" class="w4">
              <span v-if="ticket.device_fid">
                {{ ticket.device_fid }}

                <template v-if="ticket.device_name">
                  <br>
                  {{ticket.device_name}}
                </template>

              </span>
            </td>
            <td :data-label="translate('support.user')" class="w10">
              {{ ticket.user_name }}
            </td>
            <td :data-label="translate('support.status')" class="w3">
              <span class="badge" :class="ticket_status[ticket.status].color">
                {{ ticket_status[ticket.status].title }}
              </span>
            </td>
            <td :data-label="translate('support.update')" class="w4">
              {{ get_date_update(ticket.ts_update) }}
            </td>
            <td :data-label="translate('support.user_update')" class="w10">
              {{ ticket.user_updated }}
            </td>
            <td :data-label="translate('support.executor')" class="w10">
              {{ ticket.executor_user_name }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import NewTicket from './NewTicket'
import ShowTicket from './ShowTicket'

export default {
  name: 'ListTickets',
  props: ['filter_asc','filter_type','tickets', 'show_new_ticket', 'device_id'],
  data () {
    return {
      search: '',
      check_search: false,
      loading: true
    }
  },
  created(){
    if (this.tickets && this.tickets.length > 0) {
      this.loading = false
    }
  },
  computed:{
    ticket_status () {
      return this.$store.getters.getTicketStatus
    },
    permissions(){
      return this.$store.getters.getPermissions
    },
  },
  watch:{
    tickets(){
      if (this.tickets && this.tickets.length > 0) {
        this.loading = false
      }
    }
  },
  methods: {
    get_search(){
      this.check_search = true
      let obj = {text: this.search}
      if (this.device_id) {
        obj.device_id = +this.device_id
      }
      this.$http.v1.supportSearch(obj, (response) => {
        this.$emit('change_list', response.data)
      })
    },
    clear_search(){
      this.search = ''
      this.check_search = false
      this.$emit('clear_list')
    },
    change_filter(type){
      this.$emit('change_filter', type)
    },

    get_date_update(ts){
      let date = Math.floor(new Date(ts * 1000) / 1000)
      let this_date = Math.floor(new Date / 1000)

      var duration = Math.round(this_date - date);
      let minutes = 0
      let hours = Math.round(duration/(60*60));
      let days = 0

      if (hours > 48) {
        return this.get_date(date)
      }else if(hours > 24 && hours <= 48){
        hours = Math.round(((duration/60)%60)%24);
        days = Math.round(((duration/60)/60)/24);
        return days + " " + this.translate('simcard_devices.d_ago') + " " + hours + " " + this.translate('simcard_devices.h_ago')
      }else if (hours >= 1 && hours <= 24) {
        return hours + " " + this.translate('simcard_devices.h_ago')
      }else if (hours < 1) {
        minutes = Math.round(duration/60);
        return minutes + " " + this.translate('simcard_devices.min_ago')
      }
    },

    new_ticket (val) {
      let t = this.$createElement(NewTicket, {props: {ticket: val}, on: {
        close: () => { this.$modal.hide('dynamic-modal') },
      }})
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },

    show_ticket(ticket_id){
      this.$emit('check_link')
      this.$http.v1.getTicketInfo(ticket_id, (response) => {
            let ticket_data = response.data
            let t = this.$createElement(ShowTicket, {props: {ticket: ticket_data, check: false}, on: {
            close: () => { this.$modal.hide('dynamic-modal') },
            reload: () => {
              this.$emit('reload_tickets')
              this.$store.dispatch('ticketList')
            }
          }})
          let temp = {
            render () { return t }
          }
          this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading{
    border:none;
    background-color:  transparent;
    height: 70px;
  }
  .wrap{
    height: 100%;
  }
  .support_header{
    height: 10%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 15px 0;
    .form-group{
      margin-bottom: 0;
      width: 100%;
      position: relative;
      .form-control{
        border-radius: 4px 0 0 4px;
        border: 1px solid #ccc;
      }
      &--wrap{
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        width: 50%;

        span{
          height: 40px;
          border-radius: 0 4px 4px 0;
          font-size: 16px;
          padding: 7px 10px;
        }
      }
      .mdi-close{
        position: absolute;
        right: 0;
        top: calc(50% - 7px);
        color: darksalmon;
        cursor: pointer;
      }
    }
    .btn-fill{
      height: 40px;
    }
  }
  .ticket{
    cursor: pointer;
    padding: 2px;
    &:hover{
      background-color: #eee;
    }
  }
  .response_table{
    height: 90%;
    table{
      height: 100%;
      thead{
        height: 50px;
        flex:0;
        display: inline-block;
      }
      td,th{
        &.w1{
          width: 2.5%;
        }
        &.w3{
          width: 7.5%;
        }
        &.w4{
          width: 10%;
        }
        &.w10{
          width: 25%;
        }
      }
      th{
        i{
          opacity: 0;
          width: 0;
          display: inline-block;
        }
        &.selected{
          color: #000;
          i{
            opacity: 1;
            width: auto;
          }
        }
      }
    }
  }

  .pointer{
    cursor: pointer;
  }

  .mdi-arrow-down{
    transform: rotate(0);
    transition: 0.2s;
    &.reverse::before{
      transform: rotate(180deg);
    }
  }

  @media (max-width: 1366px) {
    .support_header{
      height: 85px;
      padding: 10px 0;
    }
    .response_table{
      padding: 1vh 0 0;
      table{
        font-size: 13px;
        td,th{
          &.w1{
            width: 30px;
          }
          &.w3{
            width: 80px;
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
    .response_table{
      table{
        font-size: 12px;
        td,th{
          &.w4{
            width: 90px;
          }
        }
      }
    }
  }

  @media (max-width: 500px){
    .response_table{
      padding: 0 10px;
    }
    .support_header{
      .btn-fill{
        b{
          display: none;
        }
      }
      .form-group{
        &--wrap{
          width: 100%;
          margin-right: 10px;
        }
      }
    }
  }
</style>
